/* yv-cart-v5.js - cart drawer Version 5 behaviour (9 Oct 2026). Loaded by snippets/cart-drawer.liquid. */
(function () {
  if (window.__yv5DrawerReady) return;
  window.__yv5DrawerReady = true;

  /* Add an offer (upgrade switch or "+ Add"): same request the old drawer
     made, then Dawn re-renders the whole drawer from the response. */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-yv5-add]');
    if (!btn || !btn.closest('cart-drawer')) return;
    event.preventDefault();
    if (btn.disabled) return;
    btn.disabled = true;
    btn.classList.add('is-busy');
    if (btn.classList.contains('yv5-switch')) { btn.classList.add('is-on'); btn.setAttribute('aria-checked', 'true'); }
    else { btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; }
    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(btn.getAttribute('data-yv5-add')), quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (state) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(state);
        else window.location.reload();
      })
      .catch(function () {
        btn.disabled = false;
        btn.classList.remove('is-busy', 'is-on');
        btn.setAttribute('aria-checked', 'false');
        if (btn.dataset.label) btn.textContent = btn.dataset.label;
        var s = document.querySelector('.yv5-offers__status');
        if (s) s.textContent = 'This item could not be added. Please try again.';
      });
  });

  /* The free-soap line on the checkout button.
     Shiprocket's script swaps our #CartDrawer-Checkout for its own
     .shiprocket-headless > button.sr-headless-checkout ("BUY NOW"), so the
     line is added INTO their button, under BUY NOW, whenever the cart is at
     Rs 1,000+ (data-yv5-soap="on" on .cart-drawer__footer, which Liquid
     sets). Their button and its onclick are not otherwise touched. If their
     script does not load, our own button shows the same line (.is-soap). */
  function syncSoap() {
    var f = document.querySelector('#CartDrawer .cart-drawer__footer');
    if (!f) return;
    var on = f.getAttribute('data-yv5-soap') === 'on';
    var b = document.getElementById('CartDrawer-Checkout');
    if (b) b.classList.toggle('is-soap', on);
    var sr = document.querySelector('#CartDrawer .cart__ctas .sr-headless-checkout');
    if (!sr) return;
    var have = sr.querySelector('.yv5-sr-soap');
    if (on && !have) {
      var t = document.getElementById('Yv5SoapLine');
      if (!t) return;
      var node = t.content.firstElementChild.cloneNode(true);
      var row = sr.querySelector('.sr-d-flex.full-width');
      if (row && row.parentNode) row.parentNode.insertBefore(node, row.nextSibling); else sr.appendChild(node);
    } else if (!on && have) {
      have.remove();
    }
  }
  function boot() {
    var d = document.querySelector('cart-drawer');
    if (d) new MutationObserver(syncSoap).observe(d, { childList: true, subtree: true });
    syncSoap();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
